import { uiRows } from './types-def.js';
/**
 * `web/views` (2.K; CS r4b deliverable 122, and the Views menu's row by DECISIONS 179): saved views
 * on the catalogue toolbar and their page. Every action has a visible control (DECISIONS 161). The
 * brief's names (`views.save`, `views.update`, `views.remove`, `views.pin`, `views.layout`,
 * `views.open`) take a middle part, as every UI row id has three (`ui-rows.test.ts`).
 */
export const VIEWS_INTERACTIONS = uiRows([
    {
        id: 'views.list.open',
        module: 'web/views',
        behavior: 'The "Views" button opens a menu of the type\'s saved views; choosing one opens its page',
        owner: '2.K',
        since: 'exit-2a',
    },
    {
        id: 'views.toolbar.save',
        module: 'web/views',
        behavior: '"Save view" on the catalogue toolbar saves the current filters, sort and columns as a named view',
        owner: '2.K',
        since: 'exit-2a',
    },
    {
        id: 'views.toolbar.update',
        module: 'web/views',
        behavior: '"Update view" saves a changed view in place, and "Rename" renames it',
        owner: '2.K',
        since: 'exit-2a',
    },
    {
        id: 'views.page.remove',
        module: 'web/views',
        behavior: '"Delete" removes the view and its sidebar pin after a confirmation',
        owner: '2.K',
        since: 'exit-2a',
    },
    {
        id: 'views.page.pin',
        module: 'web/views',
        behavior: '"Pin view" pins the view to the sidebar, and pressing it again unpins it',
        owner: '2.K',
        since: 'exit-2a',
    },
    {
        id: 'views.page.layout',
        module: 'web/views',
        behavior: 'The layout choice switches the view between Table and List and saves it',
        owner: '2.K',
        since: 'exit-2a',
    },
]);
//# sourceMappingURL=views.js.map